import { Box, Button, Chip, CircularProgress, Container, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import author from "../../assets/img/author.png"
import { themePalette } from "../../config/theme.config";
import { useContext, useEffect, useState } from "react";
import { I18nContext } from "../../I18nProvider";
import IresearhService from "../../services/IresearchService";
import { Colaboraciones } from "./Investigador/Colaboraciones";
import { ProyectoOds } from "../../Interface/IProyectoOds";
import { Publicacion } from "../../Interface/IPublicacionOds";
import { Publicaciones } from "./Publicaciones";
import { Proyectos } from "./Proyecto";
import { useParams } from "react-router-dom";
import { AuthorData, CitAutorAnual, Persona, PubAutorAnual } from "../../Interface/IPersona";

import { BarChart } from "@mui/x-charts/BarChart/BarChart";
import { NotFoundPage } from "../Error/ErrorNotFound";
import { Colaborador } from "../../Interface/IInvestigadorUnidad";
import { TbSearch, TbX } from "react-icons/tb";


const componentsMap: Record<"publicaciones" | "proyectos" | "colaboraciones", React.FC<any>> = {
    publicaciones: Publicaciones,
    proyectos: Proyectos,
    colaboraciones : Colaboraciones
};


export const Investigador: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const anio = new Date().getFullYear();
    const { id } = useParams<{ id: string }>();
    const [activeComponent, setActiveComponent] = useState<"publicaciones" | "proyectos" | "colaboraciones">("publicaciones");
    const ActiveComponent = componentsMap[activeComponent];
    const [proyectos, setProyectos] = useState<ProyectoOds[]>([]);
    const [loadingProy, setLoadingProy] = useState<boolean>(true);
    const [publicaciones, setPublicaiones] = useState<Publicacion[]>([]);
    const [loadingPub, setLoadingPub] = useState<boolean>(true);
    const [colaboraciones, setColaboraciones] = useState<Colaborador[]>([]);
    const [loadingCol, setLoadingCol] = useState<boolean>(true);
    const [infoPersona, setInfoPersona] = useState<Persona>()
    const [loadingInfPersona, setLoadingInfPersona] = useState<boolean>(true);
    const [dataPersona, setDataPersona] = useState<AuthorData>()
    const [loadingDataPersona, setLoadingDataPersona] = useState<boolean>(true);
    const [areas, setAreas] = useState<string[]>([])
    const [loadingAreas, setLoadingAreas] = useState<boolean>(true);
    const [pubAnuales, setpubAnuales] = useState<PubAutorAnual[]>([]);
    const xAxisDataPub = pubAnuales.map((item) => item.anio);
    const seriesDataPub = pubAnuales.map((item) => item.publicaciones);
    const [loadingGrafPub, setLoadingGrafPub] = useState<boolean>(true);
    const [citAnuales, setcitAnuales] = useState<CitAutorAnual[]>([]);
    const xAxisDataCit = citAnuales.map((item) => item.anio);
    const seriesDataCit = citAnuales.map((item) => item.citaciones);
    const [loadingGrafCit, setLoadingGrafCit] = useState<boolean>(true);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [notFound, setnotFound] = useState<boolean>(false);

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const [proyectosFil, setProyectosFil] = useState<ProyectoOds[]>([]);
    const [searchTermProy, setSearchTermProy] = useState<string>("");
    const [errorProy, setErrorProy] = useState<boolean>(false);

    const [showAll, setShowAll] = useState(false);
    const maxVisible = 6;
    const safeAreas = Array.isArray(areas) ? areas : [];
    const shouldShowButton = safeAreas.length > maxVisible;
    const visibleAreas = showAll || !shouldShowButton ? safeAreas : safeAreas.slice(0, maxVisible);

    const [totalPub, setTotalPub] = useState<number>(0);
    const [totalCit, setTotalCit] = useState<number>(0);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }


    const handleSearch = () => {
        if (searchTerm.length >= 4 && searchTerm.length <= 100) {
            setSearchQuery(searchTerm);
            setError(false);
        } else {
            setError(true);
        }
    };


    const handleReset = () => {
        setSearchTerm("")
        setSearchQuery("")

    }


    const normalizeText = (text: string) =>
        text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

   
        

    const handleSearchProy = () => {
        if (searchTermProy.length < 4 || searchTermProy.length > 100) {
            setErrorProy(true);
            return;
        }
        setErrorProy(false);
        const filtered = proyectos.filter((proyecto) =>
            normalizeText(proyecto.titulo).includes(normalizeText(searchTermProy))
        );
        setProyectosFil(filtered);
    };

    const handleResetProy = () => {
        setSearchTermProy("");
        setProyectosFil(proyectos);
        setErrorProy(false);
    };




    useEffect(() => {
        if (id) {
            IresearhService.GetContratoByScopusId(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }


                    const info: Persona = response.data;
                    setInfoPersona(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingInfPersona(false);
                });

            IresearhService.GetAuthorInfo(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }


                    const info: AuthorData = response.data;

                    setDataPersona(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingDataPersona(false);
                });

            IresearhService.GetAuthorDataAndArea(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }


                    const info: string[]= response.data.areas;
                    setAreas(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingAreas(false);
                });

            IresearhService.GetPublicationsByScopusId(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const info: PubAutorAnual[] = response.data.publicaciones.lista_publicaciones;
                    setpubAnuales(info);
                    const numpub: number = response.data.publicaciones.totalpublicaciones
                    setTotalPub(numpub)

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingGrafPub(false);
                });


            IresearhService.GetCitationsScivalByScopusId(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const info: CitAutorAnual[] = response.data.citaciones.lista_citaciones;
                    setcitAnuales(info);
                    const numcit: number = response.data.citaciones.totalcitaciones
                    setTotalCit(numcit)
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingGrafCit(false);
                });

            IresearhService.GetProyectosAuthorByScopusId(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const info: ProyectoOds[] = response.listData;
                    setProyectos(info);
                    setProyectosFil(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingProy(false);
                });

            IresearhService.GetColaboradoresEspol(id)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const info: Colaborador[] = response.data.data;
                    setColaboraciones(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingCol(false);
                });


        } else {
            console.log("No hay id Investigador");
        }
    }, [id]);
   
    useEffect(() => {
        if (id) {

            IresearhService.GetMyPublicationsByScopusId(id, page,  searchQuery)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const info: Publicacion[] = response.data.data;
                    setTotalRows(response.data.totalCount);
                    setPublicaiones(info);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingPub(false);
                });

        } else {
            console.log("No hay id Investigador");
        }
    }, [id, page,  searchQuery]);

    if (notFound) {
        return (

            <NotFoundPage />

        );
    }

    return (
        <Container style = {{ padding: '20px'}}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center" 
                spacing={2}
                sx={{ paddingY: '5px', borderBottom: `2px solid ${themePalette.NAVCOLOR}` }}
            >
                <Grid item xs={12} sm={3} md={2}>
                    <Box display="flex" justifyContent="center">
                        <img src={infoPersona?.foto ?? author} alt="Investigador" style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }} />
                    </Box>
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }} 
                >
                    {loadingInfPersona ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100px",
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <h3>
                                {infoPersona?.apellidos} {infoPersona?.nombres}
                            </h3>
                            <p>{infoPersona?.correo}</p>
                            <p>
                                    <strong>SCOPUSID:</strong>  <a href={`https://www.scopus.com/authid/detail.uri?authorId=${infoPersona?.scopusId}`} target="_blank" rel="noopener noreferrer">{infoPersona?.scopusId}</a>
                            </p>
                        </>
                    )}
                </Grid>

                <Grid item xs={12} sm={4} md={6}>
                    {loadingAreas? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100px",
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center", 
                            }}
                        >
                            <h3>{context.t.translate("investigador.areas")}</h3>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px",
                                        alignItems: "center",
                                    }}
                                >
                                    {safeAreas.length > 0 ? (
                                        visibleAreas.map((area, index) => (
                                            <Chip key={index} label={area} color="primary" sx={{ fontSize: "0.9rem" }} />
                                        ))
                                    ) : (
                                        <p>{context.t.translate("investigador.noAreas")}</p>
                                    )}

                                    {shouldShowButton && (
                                        <Button size="small" onClick={() => setShowAll(!showAll)} variant= "outlined">
                                            {showAll ? "-" : "+"}
                                        </Button>
                                    )}
                                </Box>
                        </Box>
                    )}
                </Grid>
            </Grid>


            <Grid container direction="row" spacing={2} sx={{ borderBottom: `2px solid ${themePalette.NAVCOLOR}` }} >
                <Grid item xs={12} sm={3} md={4} sx={{ justifyContent: "center", alignItems: "center" } }>
                    {loadingDataPersona ? (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                            <Box sx={{ justifyContent: "center", alignItems: "center" }}>
                                <h3>{context.t.translate("investigador.metricas")}</h3>
                                <h3>Periodo: {anio - 6} - {anio}</h3>
                                <h4>{ totalPub}</h4>
                                <p>{context.t.translate("investigador.publicaciones")}</p>
                                <h4>{totalCit}</h4>
                                <p>{context.t.translate("investigador.citaciones")}</p>
                                <h4>{dataPersona?.hIndex}</h4>
                                <p>H-index</p>
                                <h4>{dataPersona?.coautorCount}</h4>
                                <p>{context.t.translate("investigador.colaboraciones")}</p>
                            </Box>
                    )}
                </Grid>
                <Grid item xs={12} sm={9} md={8}>
                    <h3>{context.t.translate("home.estadisticas")}</h3>
                    <Grid container justifyContent="center" spacing={4} alignItems="center">
                        <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                            <h4>{context.t.translate("estadisticas.pubAnuales")}</h4>
                            {loadingGrafPub ? (
                                <CircularProgress />
                            ) : (
                                <BarChart
                                    xAxis={[{ id: "anios", data: xAxisDataPub, scaleType: "band" }]}
                                    series={[{ data: seriesDataPub }]}
                                    width={400}
                                    height={300}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                            <h4>{context.t.translate("estadisticas.citAnuales")}</h4>
                            {loadingGrafCit ? (
                                <CircularProgress />
                            ) : (
                                <BarChart
                                    xAxis={[{ id: "anios", data: xAxisDataCit, scaleType: "band" }]}
                                    series={[{ data: seriesDataCit }]}
                                    width={400}
                                    height={300}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>    
            </Grid>
            <Grid container justifyContent="center" alignItems="center" spacing={2} style={{ padding: '20px' }} >
                <Grid item xs={12} sm={2} md={2}>
                    <Button fullWidth onClick={() => setActiveComponent("publicaciones")} variant="outlined"
                        sx={{
                            color: activeComponent === "publicaciones" ? "white !important" : themePalette.NAVCOLOR,
                            backgroundColor: activeComponent === "publicaciones" ? themePalette.NAVCOLOR : "transparent",
                            borderColor: themePalette.NAVCOLOR,
                            '&:hover': {
                                backgroundColor: activeComponent === "publicaciones" ? themePalette.NAVCOLOR : "rgba(0, 0, 0, 0.1)",
                            },
                            height: {xs: "auto",md: "60px",},
                        }}
                    >{context.t.translate("investigador.publicaciones")}</Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2}>
                    <Button fullWidth onClick={() => setActiveComponent("colaboraciones")} variant="outlined"
                        sx={{
                            color: activeComponent === "colaboraciones" ? "white !important" : themePalette.NAVCOLOR,
                            backgroundColor: activeComponent === "colaboraciones"  ? themePalette.NAVCOLOR : "transparent",
                            borderColor: themePalette.NAVCOLOR,
                            '&:hover': {
                                backgroundColor: activeComponent === "colaboraciones" ? themePalette.NAVCOLOR : "rgba(0, 0, 0, 0.1)",
                            },
                            height: {xs: "auto",md: "60px",},
                        }}
                    >{context.t.translate("investigador.colaboradores")}</Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2}>
                    <Button fullWidth onClick={() => setActiveComponent("proyectos")} variant="outlined"
                        sx={{
                            color: activeComponent === "proyectos" ? "white !important" : themePalette.NAVCOLOR,
                            backgroundColor: activeComponent === "proyectos" ? themePalette.NAVCOLOR : "transparent",
                            borderColor: themePalette.NAVCOLOR,
                            '&:hover': {
                                backgroundColor: activeComponent === "proyectos" ? themePalette.NAVCOLOR : "rgba(0, 0, 0, 0.1)",
                            },
                            height: {xs: "auto",md: "60px",},
                        }}
                    >{context.t.translate("investigador.proyectos")}</Button>
                </Grid>
            </Grid>
            <Box sx={{ marginTop: "20px" }}>
                {ActiveComponent && (
                    <>
                        {activeComponent === "publicaciones" ? (
                            loadingPub ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                    <Grid container justifyContent="center" alignItems="center" spacing={2} >

                                        <Grid item xs={12} sm={7} md={7} sx={{ marginBottom: "10px" }}>
                                            <TextField
                                                label="Búsqueda de Publicación"
                                                variant="outlined"
                                                fullWidth
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleSearch();
                                                    }
                                                }}
                                                error={error}
                                                helperText={error ? "El texto debe tener de 4 a 100 caracteres" : ""}
                                                InputProps={{
                                                    endAdornment: (

                                                        <InputAdornment position="end">

                                                            {searchTerm && (
                                                                <IconButton
                                                                    sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                    onClick={handleReset}
                                                                >
                                                                    <TbX />
                                                                </IconButton>
                                                            )}

                                                            <IconButton
                                                                sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                onClick={handleSearch}
                                                            >
                                                                <TbSearch />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    <ActiveComponent
                                        publicaciones={publicaciones || []}
                                        totalRows={totalRows}
                                        page={page}
                                        setPage={setPage}
                                        />

                                </Grid>
                            )
                        ) : activeComponent === "proyectos" ? (
                            loadingProy ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                        <Grid container justifyContent="center" alignItems="center" spacing={2} >

                                            <Grid item xs={12} sm={7} md={7} sx={{ marginBottom: "10px" }}>

                                                <TextField
                                                    label="Búsqueda de Proyectos"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={searchTermProy}
                                                    onChange={(e) => setSearchTermProy(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            handleSearchProy();
                                                        }
                                                    }}
                                                    error={errorProy}
                                                    helperText={errorProy ? "El texto debe tener de 4 a 100 caracteres" : ""}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {searchTermProy && (
                                                                    <IconButton
                                                                        sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                        onClick={handleResetProy}
                                                                    >
                                                                        <TbX />
                                                                    </IconButton>
                                                                )}
                                                                <IconButton
                                                                    sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                    onClick={handleSearchProy}
                                                                >
                                                                    <TbSearch />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <ActiveComponent proyectos={proyectosFil || []} />
                                        </Grid>
                            )
                        ) : activeComponent === "colaboraciones" ? (
                            loadingCol ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                                    <CircularProgress />
                                </Box>
                            ) : (

                                <ActiveComponent colaboraciones={colaboraciones || []} />
                            )
                        ) : null}
                    </>
                )}
            </Box>





        </Container>
    );
};
